module.exports = __webpack_public_path__ + "assets/07675ff839ef138cbfb4c7a62ad447d9.svg";